import { render, staticRenderFns } from "./covenantDetail.vue?vue&type=template&id=1fa60214&scoped=true"
import script from "./covenantDetail.vue?vue&type=script&lang=js"
export * from "./covenantDetail.vue?vue&type=script&lang=js"
import style0 from "./covenantDetail.vue?vue&type=style&index=0&id=1fa60214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa60214",
  null
  
)

export default component.exports